"use client"

import { useConfigParams } from "@/hooks/use-config-params"
import { trackAnalyticsEvent } from "@/lib/analytics"
import { ReactNode } from "react"

export function PdvBannerRedirect({ children }: { children: ReactNode }) {
  const { channel } = useConfigParams()
  const cancelCallbackUrl = window.location.href

  const redirectUrl = `/registrazioneJwt/registrazione-pdv?siteid=${channel}&cancelcallbackurl=${cancelCallbackUrl}`

  const handleClick = () => {
    trackAnalyticsEvent({
      event: "link_click",
      event_name: "nav_click",
      conversion_pagename: "login",
      position: "login",
      cta_label: "attivalo qui",
    })
  }

  return (
    <a href={redirectUrl} onClick={handleClick}>
      {children}
    </a>
  )
}
